
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServiceNav from './components/ServiceNav';
import ServiceDetail from './components/ServiceDetail';
import WhyChooseUs from './components/WhyChooseUs';
import ServicesFAQ from './components/ServicesFAQ';
import ServicesQuoteForm from './components/ServicesQuoteForm';
import { servicesData } from '../../mocks/servicesData';

export default function ServicesPage() {
  const [activeService, setActiveService] = useState(servicesData[0].id);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const sections = servicesData.map((s) => ({
        id: s.id,
        el: document.getElementById(s.id),
      }));

      for (const section of sections) {
        if (section.el) {
          const rect = section.el.getBoundingClientRect();
          if (rect.top <= 200 && rect.bottom > 200) {
            setActiveService(section.id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleServiceClick = (id: string) => {
    setActiveService(id);
    const el = document.getElementById(id);
    if (el) {
      const offset = 120;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServicesHero />
      <ServiceNav activeService={activeService} onServiceClick={handleServiceClick} />

      <main>
        {servicesData.map((service, index) => (
          <ServiceDetail key={service.id} service={service} index={index} />
        ))}
      </main>

      <WhyChooseUs />
      <ServicesFAQ />
      <ServicesQuoteForm />
      <Footer />
    </div>
  );
}
